// No additional imports needed
import UserDropdown from "@/components/UserDropdown";
import GlobalSearch from "@/components/globalSearch";

import { SideMenuToggle } from "./SideMenu/components/SideMenuToggle";

function MobileHeader() {
    return (
        <div className="md:hidden bg-elitDarkBlue text-white px-4 py-2 mb-3 flex items-center justify-between shadow-lg h-12">
            {/* Left side - Menu */}
            <div className="flex items-center">
                <SideMenuToggle />
            </div>

            {/* Right side - User */}
            <div className="flex items-center">
                <GlobalSearch />
                <UserDropdown />
            </div>
        </div>
    );
}

export default MobileHeader;
